var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facial-features q-w940 q-fit"},[_c('question-with-error-wrap',{attrs:{"error":_vm.getFieldsError(['wrinkles'])}},[_c('face-lines-input',{attrs:{"gender":_vm.gender,"value":_vm.wrinkles},on:{"input":function($event){return _vm.onFieldChange('wrinkles', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }